/* eslint-disable */ // looks like third party code, probably not worth fixing linter errors

import React from 'react';
import * as d3 from 'd3';

const $ = d3.select.bind(d3);
const HEIGHT = 30;
const WAVES = 3;
const SMOOTH_DISTANCE = 75;

// draw & animate
let progress = 0;
let direction = 1;

// Wave class
class Wave {
  constructor(svg, width, wavelength, amplitude, offset, opacity) {
    this.piScaled = (Math.PI * 2) / wavelength;
    this.amplitude = amplitude;
    this.offset = offset;
    this.opacity = opacity;
    this.width = width;

    this.path = svg
      .append('path')
      .attr('stroke', 'url(#loaderGradient)')
      .attr('fill', 'none')
      .attr('stroke-opacity', opacity);
    this.line = d3
      .line()
      .x(v => v.index)
      .y(v => {
        // scale it off if it exceeds the progress
        let scale = 1;
        let exceedingAmount =
          Math.abs(this.width / 2 - v.index) - ((this.width / 2) * progress - SMOOTH_DISTANCE / 2);

        scale =
          Math.cos(
            (Math.PI * Math.max(0, Math.min(SMOOTH_DISTANCE, exceedingAmount))) / SMOOTH_DISTANCE
          ) /
            2 +
          0.5;
        return HEIGHT / 2 + v.value * scale;
      });
  }

  draw() {
    this.path.attr('d', this.generatePath());
  }

  generatePath() {
    const points = [];
    for (let i = 0; i < this.width; ++i) {
      points.push({
        value: Math.sin((i + this.offset) * this.piScaled) * this.amplitude,
        index: i
      });
    }
    return this.line(points);
  }
}

export default class Waves extends React.Component {
  shouldComponentUpdate() {
    return false;
  }
  componentDidMount() {
    const WIDTH = 555;
    // generate the loader
    const svg = $(this.svg).attr('width', WIDTH).attr('height', HEIGHT);

    // generate waves
    const waves = [];
    for (let i = 0; i < WAVES; ++i) {
      var w = new Wave(
        svg,
        WIDTH,
        2.5 * HEIGHT + Math.random() * HEIGHT * 8, // wavelength
        HEIGHT / 2 - (Math.random() * HEIGHT) / 4, // amplitude
        (25 / WAVES) * i + Math.random() * 5, // offset
        0.25 + Math.random() * 0.75 // opacity
      );
      w.draw();
      waves.push(w);
    }

    function draw(dT) {
      if (progress > 1 && direction > 0) {
        direction = -5;
      } else if (progress < 0 && direction < 0) {
        direction = 1;
      }
      progress += 0.003 * direction;
      for (let i = 0; i < waves.length; ++i) {
        waves[i].offset += (((i + 1) % 2) * 2 - 1) * (Math.random() * 0.2 + 0.9);
        waves[i].draw();
      }
      requestAnimationFrame(draw);
    }
    draw();
  }

  render() {
    return (
      <div className="waves-container">
        <svg
          className="waves"
          ref={el => {
            this.svg = el;
          }}
        >
          <defs>
            <linearGradient id="loaderGradient">
              <stop offset="0%" stopColor="#6bd0e4" />
              <stop offset="33%" stopColor="#604eb1" />
              <stop offset="66%" stopColor="#c88e66" />
              <stop offset="100%" stopColor="#c955a9" />
            </linearGradient>
          </defs>
        </svg>
        <style jsx global>{`
          .waves-container {
            position: relative;
            width: 100%;
            height: 50px;
          }
          
          .waves {
            left: 0%;
            right: 0%;
            width: 100%;
            position: absolute;
            transform: scale(1.5);
          }
          
          .waves path {
            stroke-width: 2px;
          }
        `}</style>
      </div>
    );
  }
}
